export default {
  stepNotFound: 'Stap niet gevonden',
  noDescription: 'Geen beschrijving',
  expectedStartDate: 'Verwachte startdatum',
  batchName: 'Batchnaam',
  nextStep: 'Volgende stap',
  noUpcomingSteps: 'Geen komende stappen'
};
